import { adams } from 'app/scripts/lib/adams';
import { templateHelpers } from './templateHelpers';

export const teacupWithHelpers = templateHelpers(adams);
